import React from 'react';
import PropTypes from 'prop-types';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import DataGridActions from './DataGridActions';
import DataGridFilters from './DataGridFilters';
import styled from 'styled-components';
import DataGridSearch from './DataGridSearch';

const DataGridToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing()}px;
`;

const DataGridToolbar = ({ actions, filterRenderers }) => {
  const { hasModule } = useDataSourceContext();
  const hasFiltersModule = hasModule('filters');
  const hasSearchModule = hasModule('search');

  return (
    <DataGridToolbarContainer>
      {hasSearchModule && <DataGridSearch />}
      {hasFiltersModule ? (
        <DataGridFilters filterRenderers={filterRenderers} />
      ) : (
        <div style={{ flex: 1 }} />
      )}
      <DataGridActions actions={actions} />
    </DataGridToolbarContainer>
  );
};

DataGridToolbar.propTypes = {
  actions: PropTypes.array,
  filterRenderers: PropTypes.object,
};

DataGridToolbar.defaultProps = {
  actions: [],
  filterRenderers: {},
};

export default DataGridToolbar;
